import React, { useState } from 'react';
import { c as classnames } from './index-2586sEvh.js';

const RadioButton = ({ name, selectedValue, optionValue, label, disabled = false, inputClassName = '', onChange, loading = false, ...rest }) => {
    const [inputFocussed, setInputFocussed] = useState(false);
    const handleFocus = () => {
        if (!loading) {
            setInputFocussed(true);
        }
    };
    return (React.createElement("div", { "data-testid": optionValue, className: classnames('radio-button-container', { disabled }, inputFocussed && !loading && 'focussed') },
        React.createElement("label", { style: {
                cursor: loading ? 'progress' : 'pointer',
            } },
            React.createElement("input", { type: "radio", name: `${name}-${optionValue}`, value: optionValue, checked: selectedValue === optionValue, disabled: disabled, onChange: onChange, onFocus: handleFocus, onBlur: () => setInputFocussed(false), className: inputClassName, ...rest }),
            label,
            disabled && React.createElement("div", { className: "disabled-line" }))));
};

export { RadioButton as R };
//# sourceMappingURL=RadioButton--4-l0gXo.js.map
